import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type AnalyticsTab =
  | 'training-intelligence'
  | 'running'
  | 'fitness'
  | 'performance'
  | 'body';

interface AnalyticsState {
  activeTab: AnalyticsTab;
  setActiveTab: (tab: AnalyticsTab) => void;
}

export const useAnalyticsStore = create<AnalyticsState>()(
  persist(
    (set) => ({
      activeTab: 'training-intelligence',
      setActiveTab: (activeTab) => set({ activeTab }),
    }),
    {
      name: 'analytics-store',
      partialize: (state) => ({ activeTab: state.activeTab }),
    }
  )
);
